<template>
    <li>
        <div class="item"
             :class="estSousMenu ? 'sous-menu' : (estTable ? 'feuille-table' : 'feuille-action')"
             @click.stop="clic">
            <span v-if="estSousMenu" class="prefixe">{{ ouvert ? '▼ ' : '▶ ' }}</span>
            <span class="libelle">{{ noeud.label }}</span>
        </div>
        <ul v-if="estSousMenu && ouvert" class="niveau">
            <MenuNoeud v-for="(n, i) in noeud.enfants" :key="i" :noeud="n"
                       @ouvrir="$emit('ouvrir', $event)" @action="$emit('action', $event)" />
        </ul>
    </li>
</template>

<script>
    import { defineComponent } from 'vue';

    // Sous-composant recursif : rend un noeud de menu (feuille ou sous-menu deployable).
    // Composant recursif : il se reference lui-meme dans son template via son "name".
    export default defineComponent({
        name: 'MenuNoeud',
        props: { noeud: { type: Object, required: true } },
        emits: ['ouvrir', 'action'],
        data() { return { ouvert: false }; },
        computed: {
            estSousMenu() { return !!this.noeud.enfants; },
            estTable() { return this.noeud.typpar !== undefined; },
        },
        methods: {
            clic() {
                if (this.estSousMenu) { this.ouvert = !this.ouvert; return; }
                if (this.estTable) { this.$emit('ouvrir', this.noeud.typpar); return; }
                if (this.noeud.action) { this.$emit('action', this.noeud); }
            },
        },
    });
</script>

<style scoped>
    /* display explicite : neutralise une regle globale "ul { display:none }" qui  */
    /* fuit d'un autre composant (FicheDescriptive.vue, style non scoped).         */
    ul.niveau { display: block; list-style: none; padding-left: 16px; margin: 0; }
    .item {
        padding: 6px 10px;
        cursor: pointer;
        border-bottom: 1px solid #eef2f7;
        user-select: none;
    }
    .item:hover { background: #eaf1fb; }
    .item.sous-menu { font-weight: bold; color: #01358D; }
    .item.feuille-table { color: #004AAD; }
    .item.feuille-action { color: #555; }
</style>
